import { Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconVariable, Tag } from 'ui'
import { CardItem } from './CardItem'
import { CardLine } from './CardLine'
import { messages } from './messages'

const VARIABLES = [
  {
    description: messages.variable.total,
    variable: 'total',
  },
  {
    description: messages.variable.freight,
    variable: 'freight',
  },
  {
    description: messages.variable.quantity,
    variable: 'quantity',
  },
]

export function VariablesCard() {
  const { $t } = useIntl()

  return (
    <CardItem
      name="variables"
      icon={<IconVariable />}
      title={$t(messages.variable.title)}
      link={$t(messages.variable.link)}
    >
      {VARIABLES.map(({ description, variable }, index) => (
        <CardLine columns="split" key={index}>
          <div>
            <Tag>{variable}</Tag>
          </div>
          <Text>
            <FormattedMessage {...description} />
          </Text>
        </CardLine>
      ))}
    </CardItem>
  )
}
